import { useEffect, useState, Fragment } from "react";  // ✅ Import Fragment correctly
import {
    Box,
    Button,
    TextField,
    useMediaQuery,
    Typography,
    useTheme,
} from "@mui/material";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import styles from "./styles.module.css";

const EmailVerify = () => {
    const [validUrl, setValidUrl] = useState(false);
    const param = useParams();

    useEffect(() => {
        const verifyEmailUrl = async () => {
            try {
                const url = `https://my-pers-thing-server.onrender.com/users/${param.id}/verify/${param.token}`;
                const { data } = await axios.get(url);
                // console.log(data);
                setValidUrl(true);
            } catch (error) {
                // console.log(error);
                setValidUrl(false);
            }
        };
        verifyEmailUrl();
    }, [param]);

    return (
        <Fragment>
            {validUrl ? (
                <div className={styles.container}>
                    {/* <h1>Email verified successfully</h1> */}
                    <Typography
    variant="h4"
    sx={{
        textAlign: "center",
        fontSize: "25px",
        color: "#3B3B3B", // Dark gray for a modern, premium feel
        // marginTop: "10px", // ✅ Moves text down
        marginBottom: "10px", // Adds space after heading
        textTransform: "uppercase",
    }}
>
   ** Email verified successfully **
</Typography>
                    <Link to="/login">
                    
                    <Button
                                fullWidth
                                type="submit"
                                sx={{
                                    m: "2rem 0",
                                    p: "1rem",
                                    width: "120px",
                                    background: "linear-gradient(135deg, #FF61D2 0%, #FE9090 100%)",
                                    color: "#fff",
                                    borderRadius: "50px",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        background: "linear-gradient(135deg, #FE9090 0%, #FF61D2 100%)",
                                        transform: "scale(1.05)",
                                    },
                                }}
                            >
                                LOGIN
                            </Button>
                    </Link>
                </div>
            ) : (
                <h1>404 Not Found</h1>
            )}
        </Fragment>
    );
};

export default EmailVerify;
